<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="项目/联系人/电话" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.customer_id"  clearable filterable  placeholder="甲方">
                                        <Option :value="item.id" v-for="(item,index) in customerList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.type_id"  clearable filterable  placeholder="类型">
                                        <Option :value="item.type_id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.head_id"  clearable filterable  placeholder="负责人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.work_id"  clearable filterable  placeholder="施工人员">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建项目</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="project_id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" fixed-shadow="hide" no-data-text="暂无数据记录">
                                <template #name="{ row }">
                                    <div @click="showData(row.project_id)" class="d-width text-primary cursor" :title="row.name">
                                        <span>{{row.name}}</span>
                                    </div>
                                </template>
                                <template #money="{ row }">
                                    <div class="d-width" :title="row.money">
                                        <strong class="text-violet">{{row.money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #collection_money="{ row }">
                                    <div class="d-width" :title="row.collection_money">
                                        <strong class="text-success">{{row.collection_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #debt_money="{ row }">
                                    <div class="d-width" :title="row.debt_money">
                                        <strong class="text-danger">{{row.debt_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #expend_money="{ row }">
                                    <div class="d-width" :title="row.expend_money">
                                        <strong class="text-orange">{{row.expend_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #expense_money="{ row }">
                                    <div class="d-width" :title="row.expense_money">
                                        <strong class="text-orange">{{row.expense_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #balance_money="{ row }">
                                    <div class="d-width" :title="row.balance_money">
                                        <strong :class="!!row.balance_money && row.balance_money > 0 ? 'text-success':'text-danger'">{{row.balance_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #invoice_money="{ row }">
                                    <div class="d-width" :title="row.invoice_money">
                                        <strong class="text-primary">{{row.invoice_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #work_id="{ row }">
                                    <div class="d-width">
                                        <Tag v-for="(item,idx) in row.work_list" :key="idx">{{item.real_name}}</Tag>
                                    </div>
                                </template>
                                <template #start_work_time="{ row }">
                                    <div class="d-width" :title="row.start_work_time">
                                        {{row.start_work_time}}
                                    </div>
                                </template>
                                <template #work_duration="{ row }">
                                    <div class="d-width" :title="row.work_duration">
                                        {{row.work_duration?row.work_duration:'-'}}
                                    </div>
                                </template>
                                <template #work_expected_time="{ row }">
                                    <div class="d-width" :title="row.work_expected_time">
                                        {{row.work_expected_time?row.work_expected_time:'-'}}
                                    </div>
                                </template>
                                <template #company="{ row }">
                                    <div @click="customerData(row.customer_id)" class="d-width cursor" :title="row.company">
                                        <Poptip trigger="hover" title="联系方式" >
                                            <span>{{row.company}}</span>
                                            <template #content>
                                                <p>公司：{{row.company}}</p>
                                                <p>称呼：{{row.customer_real_name}}</p>
                                                <p>电话：{{row.customer_mobile}}</p>
                                                <p v-if="!!row.customer_wechat">微信：{{row.customer_wechat}}</p>
                                            </template>
                                        </Poptip>
                                    </div>
                                </template>
                                <template #type_id="{ row }">
                                    <div class="d-width" :title="row.type_name">
                                        <Tag>{{row.type_name}}</Tag>
                                    </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 8" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 9" color="purple" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 11" color="purple" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 10" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else color="#999999" :text="row.status_name" />
                                </template>
                                <template #action="{ row }">
                                    <a class="text-font-sm text-orange" title="确认完工" v-if="row.status === 8" @click="completedData(row.project_id, row.name)">确认完工</a>
                                    <a class="text-font-sm text-orange" title="确认修复" v-if="row.status === 10 " @click="completedData(row.project_id, row.name)">确认修复</a>
                                    <a class="text-font-sm text-violet" title="确认验收" v-if="row.status === 9 " @click="AcceptanceData(row.project_id, row.name)">确认验收</a>
                                    <a class="text-font-sm text-primary" title="项目审计" v-if="row.status === 11 " @click="auditData(row.project_id, row.name)">项目审计</a>
                                    <Divider v-if="row.status === 8 || row.status === 9 || row.status === 10 || row.status === 11" type="vertical"/>
                                    <a class="text-font-sm text-violet" @click="logData(row.project_id, row.name)">日志</a>
                                    <Divider type="vertical" v-if="$store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2" />
                                    <a class="text-font-sm text-primary" @click="editData(row.project_id)" v-if="$store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2">编辑</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 详情  -->
                    <show-modal v-if="is_show" ref="ShowRef"></show-modal>

                    <!-- 客户详情 -->
                    <customer-show-modal v-if="is_customer" ref="CustomerRef"></customer-show-modal>

                    <!-- 项目施工  -->
                    <work-true-modal v-if="is_work_true" ref="WorkTrueRef" @trueHandler="saveData"></work-true-modal>

                    <!-- 项目完工  -->
                    <work-completed-modal v-if="is_work_completed" ref="WorkCompletedRef" @trueHandler="saveData"></work-completed-modal>

                    <!-- 项目验收  -->
                    <work-acceptance-modal v-if="is_work_acceptance" ref="WorkAcceptanceRef" @trueHandler="saveData"></work-acceptance-modal>

                    <!-- 项目审计  -->
                    <audit-modal v-if="is_audit" ref="AuditRef" @trueHandler="saveData"></audit-modal>

                    <!-- 项目日志  -->
                    <log-modal v-if="is_log" ref="LogRef"></log-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import {getProjectConfig, getProjectWorkList} from '@/apis/project'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "../public/Create";
import LogModal from "../public/Log";
import ShowModal from "../public/Show";
import WorkTrueModal from "../public/WorkTrue";
import AuditModal from "../public/Audit";
import WorkCompletedModal from "../public/Completed";
import WorkAcceptanceModal from "../public/Acceptance";
import CustomerShowModal from "../../customer/index/Show";
import expandRow from "../public/Expand";
export default {
    name: "ProjectWork",
    components: {
        Headers, Side, AddModal, ShowModal, LogModal, CustomerShowModal, WorkTrueModal, WorkCompletedModal, WorkAcceptanceModal, AuditModal
    },
    data () {
        return {
            typeList: [],
            customerList: [],
            userList: [],

            search: {
                name: '',
                type_id: '',
                customer_id: '',
                head_id: '',
                work_id: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    type: 'expand',
                    width: 50,
                    render: (h, data) => {
                        return h(expandRow, {
                            ref: `projectView_${data.index}`,
                            rowData: data.row, // 传参
                            onReloadData:(project_id) => {
                                let that = this;
                                //确保dom更新完成
                                this.$nextTick(() => {
                                    that.getListRefresh(project_id);
                                })
                            }
                        })
                    }
                },
                {
                    title: '项目名称',
                    key: 'name',
                    slot: 'name',
                    minWidth: 160,
                },
                {
                    title: '项目金额',
                    key: 'money',
                    slot: 'money',
                    width: 120
                },
                {
                    title: '项目回款',
                    key: 'collection_money',
                    slot: 'collection_money',
                    width: 120
                },
                {
                    title: '项目欠款',
                    key: 'debt_money',
                    slot: 'debt_money',
                    width: 120
                },
                {
                    title: '项目支出',
                    key: 'expend_money',
                    slot: 'expend_money',
                    width: 120
                },
                {
                    title: '日常报销',
                    key: 'expense_money',
                    slot: 'expense_money',
                    width: 120
                },
                {
                    title: '项目结余',
                    key: 'balance_money',
                    slot: 'balance_money',
                    width: 120
                },
                {
                    title: '开票金额',
                    key: 'invoice_money',
                    slot: 'invoice_money',
                    width: 120
                },
                // {
                //     title: '施工人员',
                //     key: 'work_id',
                //     slot: 'work_id',
                //     width: 200
                // },
                {
                    title: '开工日期',
                    key: 'start_work_time',
                    slot: 'start_work_time',
                    width: 120
                },
                {
                    title: '项目进度',
                    key: 'status',
                    slot : 'status',
                    width:120
                },
                {
                    title: '项目工期',
                    key: 'work_duration',
                    slot : 'work_duration',
                    width:120
                },
                {
                    title: '完工日期',
                    key: 'work_expected_time',
                    slot : 'work_expected_time',
                    width:120
                },
                {
                    title: '甲方',
                    key: 'company',
                    slot: 'company',
                    width: 120
                },
                // {
                //     title: '项目类型',
                //     key: 'type_id',
                //     slot: 'type_id',
                //     width: 120
                // },
                {
                    title: '负责人',
                    key: 'head_name',
                    width: 90
                },
                // {
                //     title: '更新',
                //     key: 'update_time',
                //     width:150
                // },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    width : 170
                }
            ],
            is_create : false,
            is_show : false,
            is_log : false,
            is_customer : false,
            is_work_true : false,
            is_work_completed : false,
            is_work_acceptance : false,
            is_audit : false,

        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         功能：
         time: 2026/1/24 15:26
         **/
        auditData(project_id, name){
            let that = this;
            that.is_audit = true;
            setTimeout(function(){
                that.$refs.AuditRef.show(project_id, name);
            })
        },
        /**
         功能：
         time: 2025/12/20 16:24
         **/
        customerData(customer_id){
            let that = this;
            that.is_customer = true;
            setTimeout(function(){
                that.$refs.CustomerRef.show(customer_id);
            })
        },
        /**
         功能：确认完工
         time: 2025/12/20 10:39
         **/
        completedData(project_id, name){
            let that = this;
            that.is_work_completed = true;
            setTimeout(function(){
                that.$refs.WorkCompletedRef.show(project_id, name);
            })
        },
        /**
         功能：项目验收
         time: 2025/12/27 14:38
         **/
        AcceptanceData(project_id, name){
            let that = this;
            that.is_work_acceptance = true;
            setTimeout(function(){
                that.$refs.WorkAcceptanceRef.show(project_id, name);
            })
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                type_id: '',
                customer_id: '',
                head_id: '',
                work_id: ''
            };
            that.getList();
        },
        /**
         功能：
         time: 2025/12/18 14:07
         **/
        getConfig(){
            let that = this;
            getProjectConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.customerList = e.data.customerList ?? [];
                that.userList = e.data.userList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getProjectWorkList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：Expand修改触发刷新
         time: 2025/12/26 09:55
         **/
        getListRefresh(project_id){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getProjectWorkList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
                that.dataList.data.forEach((item, index) => {
                    if(parseInt(item.project_id) === parseInt(project_id)){
                        that.dataList.data[index]._expanded = true; //展开选中的行
                    }
                })
            })
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/19 11:30
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：
         time: 2025/12/19 15:55
         **/
        editData(project_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(project_id);
            })
        },
        /**
         功能：
         time: 2025/12/19 16:04
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        logData(project_id, name ){
            let that = this;
            that.is_log = true;
            setTimeout(function(){
                that.$refs.LogRef.show(project_id, name);
            })
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        showData(project_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowRef.show(project_id);
            })
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
